import { WatchQueryFetchPolicy } from '@apollo/client';

export const FETCH_POLICIES = {
  CACHE_FIRST: 'cache-first',
  CACHE_AND_NETWORK: 'cache-and-network',
  NETWORK_ONLY: 'network-only',
  NO_CACHE: 'no-cache',
  CACHE_ONLY: 'cache-only',
  STANDBY: 'standby',
} as const satisfies Record<string, WatchQueryFetchPolicy>;
